<div *ngVar="{ editMode: editMode$ | async, site: (site$ | async) } as obj">
  <div class="flex justify-between">
    @if (obj.site) {
      <div>
        @if (!obj.editMode) {
          <aux-site-information-view [site]="obj.site" />
        }
        @if (obj.editMode) {
          <aux-site-information-edit-view
            [site]="obj.site"
            [editMode$]="editMode$"
            (formChanged)="siteDataChanged($event)"
          />
        }
      </div>
    }

    <div class="flex space-x-2">
      <aux-remove-site-button [site]="obj.site" />
      @if (!obj.editMode) {
        <aux-button
          label="Edit"
          variant="secondary"
          [disabled]="
            !siteWorkflow.hasUpdatePermission().userHasUpdateSitesPermission ||
            siteWorkflow.isPatientsFinalized()
          "
          [auxTooltip]="siteWorkflow.actionButtonsTooltip()"
          label="Edit"
          icon="Pencil"
          (click)="editMode()"
        />
      }
    </div>
  </div>
</div>
